/**
 * The upload lane's progress ring and error ink (spec 2026-09-24, Part A),
 * shared by every surface that shows a file going up: the composer's file
 * chip (AttachmentHandler) and the Knowledge upload tray (files-browser).
 */

/** The mock's progress ring: r 6.5 in a 16 box, the arc drawn by its dashoffset. */
const RING_C = 2 * Math.PI * 6.5;

export function UploadRing({ progress }: { progress: number }) {
  const p = Math.min(1, Math.max(0, progress));
  return (
    <svg
      className="h-3.5 w-3.5 flex-shrink-0 -rotate-90"
      viewBox="0 0 16 16"
      aria-hidden="true"
      data-testid="upload-ring"
    >
      <circle
        cx="8"
        cy="8"
        r="6.5"
        fill="none"
        strokeWidth="2"
        className="stroke-border-default"
      />
      <circle
        data-arc
        cx="8"
        cy="8"
        r="6.5"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        className="stroke-fg-default"
        strokeDasharray={RING_C}
        strokeDashoffset={RING_C * (1 - p)}
      />
    </svg>
  );
}

/** The mock's error ink and tint, mixed from a token that resolves (`text-error`
 *  reads `--error`, which nothing defines). 83%, not the mock's 85%: 85% reads
 *  4.44:1 on the tint in light; 83% holds 4.6:1 on it in both themes. */
export const ERROR_INK =
  "text-[color-mix(in_srgb,var(--status-error)_83%,black)]";
export const ERROR_TINT =
  "bg-[color-mix(in_srgb,var(--status-error)_9%,var(--bg-elevated))]";
